import { render, staticRenderFns } from "./DashTutoringParent.vue?vue&type=template&id=b50e2070"
import script from "./DashTutoringParent.vue?vue&type=script&lang=js"
export * from "./DashTutoringParent.vue?vue&type=script&lang=js"
import style0 from "./DashTutoringParent.vue?vue&type=style&index=0&id=b50e2070&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports